import { render } from "./LocalVideoDisplay.vue?vue&type=template&id=254165b5&scoped=true"
import script from "./LocalVideoDisplay.vue?vue&type=script&lang=js"
export * from "./LocalVideoDisplay.vue?vue&type=script&lang=js"

import "./LocalVideoDisplay.vue?vue&type=style&index=0&id=254165b5&scoped=true&lang=css"

import exportComponent from "/home/forge/staging.virtualcp.app/releases/20260928150148/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-254165b5"]])

export default __exports__